$("#extended-search-help-icon").colorbox({
    close :     "<span>x</span>",
    inline:     true,
    width :     "616px",
    transition: "none",
    opacity:    "0.8"
});

/**
 * Scripts to handle advanced styling of input fields
 * - on focus
 * - if inputs has gained value after user interaction
 */
(function() {

    // Functional helper classes

    function setFocus($elem) {
        $elem.parents(".js-form-field").addClass("is-focused")
    }

    function removeFocus($elem) {
        $elem.parents(".js-form-field").removeClass("is-focused")
    }

    function setHasValue($elem) {
        $elem.parents(".js-form-field").addClass("has-value")
    }

    function removeHasValue($elem) {
        $elem.parents(".js-form-field").removeClass("has-value")
    }

    var checkForValue = function($elem) {
        return ($elem.val().length !== 0)
    };

    var updateFieldStatus = function($elem) {
        if (checkForValue($elem)) {
            setHasValue($elem);
        } else {
            removeHasValue($elem);
        }
        removeFocus($elem);
    };

    // Init & bind events

    var $inputs = $(document).find(".js-form-input");

    $inputs.on("focus", function(e) {
        setFocus($(e.target))
    }).on("change blur", function(e) {
        updateFieldStatus($(e.target))
    });

    // init field stati on load

    $.each($inputs, function() {
        updateFieldStatus($(this))
    });
}());